"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = _123;

var _ = require("@adobe/react-spectrum-workflow/dist/123");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function _123(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_.A4u123, null));
}